/* ADORINSE — enhancement layer (Minimog feature parity)
   back-to-top · announcement rotation/dismiss · quick view · cart note/discount/
   upsells · recently viewed. Relies on theme.js globals:
   window.AD (format/routes), window.adRefreshCart, window.adOpenCart, window.adToast,
   and the `cart:render` / `cart:updated` document events. */
(function () {
  'use strict';

  var AD = window.AD || {};
  function fmt(cents) { return AD.format ? AD.format(cents) : '$' + (cents / 100).toFixed(2); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function debounce(fn, ms) {
    var t; return function () { var a = arguments, self = this; clearTimeout(t); t = setTimeout(function () { fn.apply(self, a); }, ms); };
  }
  function imgSize(src, size) { return src ? src.replace(/(\.[^.\/?]+)(\?|$)/, '_' + size + '$1$2') : ''; }

  /* ============ back to top ============ */
  var backtop = document.querySelector('[data-backtop]');
  if (backtop) {
    var btTick = false;
    function backtopCheck() { backtop.classList.toggle('show', window.scrollY > 600); btTick = false; }
    window.addEventListener('scroll', function () { if (!btTick) { btTick = true; requestAnimationFrame(backtopCheck); } }, { passive: true });
    backtopCheck();
    backtop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ============ announcement rotation + dismiss ============ */
  var announce = document.querySelector('[data-announce]');
  if (announce) {
    var annItems = announce.querySelectorAll('.announce__item');
    var annKey = 'ad:announce:' + (announce.textContent || '').replace(/\s+/g, ' ').trim().length;
    if (announce.hasAttribute('data-announce-dismiss')) {
      try { if (localStorage.getItem(annKey)) announce.classList.add('is-dismissed'); } catch (e) {}
      var annClose = announce.querySelector('[data-announce-close]');
      if (annClose) {
        annClose.addEventListener('click', function () {
          announce.classList.add('is-dismissed');
          try { localStorage.setItem(annKey, '1'); } catch (e) {}
        });
      }
    }
    if (annItems.length > 1) {
      var annIdx = 0, annSpeed = (parseInt(announce.getAttribute('data-announce-speed'), 10) || 5) * 1000;
      var annPaused = false;
      announce.addEventListener('mouseenter', function () { annPaused = true; });
      announce.addEventListener('mouseleave', function () { annPaused = false; });
      setInterval(function () {
        if (annPaused || document.hidden) return;
        annItems[annIdx].classList.remove('is-active');
        annIdx = (annIdx + 1) % annItems.length;
        annItems[annIdx].classList.add('is-active');
      }, annSpeed);
    }
  }

  /* ============ quick view ============ */
  var qvRoot = document.querySelector('[data-qv]');
  var qvState = null; // { product, opts[], qty }
  var qvCache = {};

  function qvClose() {
    if (!qvRoot) return;
    qvRoot.classList.remove('open');
    document.body.classList.remove('no-scroll');
    qvState = null;
  }
  function qvVariantFor(opts) {
    if (!qvState) return null;
    return qvState.product.variants.filter(function (v) {
      return opts.every(function (o, i) { return !o || v.options[i] === o; });
    })[0] || null;
  }
  function qvOptionValues(product) {
    // derive ordered unique values per option position from the variants list
    var names = (product.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    return names.map(function (name, i) {
      var seen = [], vals = [];
      product.variants.forEach(function (v) {
        var val = v.options[i];
        if (val && seen.indexOf(val) === -1) { seen.push(val); vals.push(val); }
      });
      return { name: name, values: vals };
    });
  }
  function qvRender() {
    var p = qvState.product;
    var opts = qvState.opts;
    var v = qvVariantFor(opts) || p.variants[0];
    var groups = qvOptionValues(p);
    var hasOptions = !(groups.length === 1 && groups[0].values.length === 1 && groups[0].values[0] === 'Default Title');
    var img = (v && v.featured_image && v.featured_image.src) || (p.images && p.images[0]) || '';
    var onSale = v && v.compare_at_price && v.compare_at_price > v.price;

    var html = '' +
      '<div class="qv-overlay" data-qv-close></div>' +
      '<div class="qv-card" role="dialog" aria-modal="true" aria-label="' + esc(p.title) + '">' +
        '<button class="qv-close" data-qv-close aria-label="Close">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
        '</button>' +
        '<div class="qv-media">' +
          '<div class="qv-img">' + (img ? '<img src="' + esc(imgSize(img, '900x')) + '" alt="' + esc(p.title) + '" data-qv-img>' : '') + '</div>' +
          (p.images && p.images.length > 1
            ? '<div class="qv-thumbs">' + p.images.slice(0, 6).map(function (im, i) {
                return '<button type="button" data-qv-thumb="' + esc(im) + '"' + (im === img ? ' class="active"' : '') + '><img src="' + esc(imgSize(im, '120x')) + '" alt=""></button>';
              }).join('') + '</div>'
            : '') +
        '</div>' +
        '<div class="qv-info">' +
          '<div class="qv-cat">' + esc(p.type || 'ADORINSE') + '</div>' +
          '<h3>' + esc(p.title) + '</h3>' +
          '<div class="qv-price">' +
            '<b data-qv-price>' + fmt(v.price) + '</b>' +
            (onSale ? '<s data-qv-compare>' + fmt(v.compare_at_price) + '</s><span class="save">Save ' + fmt(v.compare_at_price - v.price) + '</span>' : '') +
          '</div>' +
          (hasOptions ? groups.map(function (g, i) {
            return '<div class="qv-opt">' +
              '<div class="lbl">' + esc(g.name) + ' · <span data-qv-optlabel="' + i + '">' + esc(opts[i] || '') + '</span></div>' +
              '<div class="vals" data-qv-group="' + i + '">' + g.values.map(function (val) {
                return '<button type="button" data-qv-val="' + esc(val) + '"' + (opts[i] === val ? ' class="sel"' : '') + '>' + esc(val) + '</button>';
              }).join('') + '</div>' +
            '</div>';
          }).join('') : '') +
          '<div class="qv-actions">' +
            '<div class="qty-mini">' +
              '<button type="button" data-qv-q="-1" aria-label="Decrease">−</button>' +
              '<input type="number" value="' + qvState.qty + '" min="1" inputmode="numeric" data-qv-qty aria-label="Quantity">' +
              '<button type="button" data-qv-q="1" aria-label="Increase">+</button>' +
            '</div>' +
            '<button type="button" class="btn btn-primary" data-qv-add' + (v && v.available ? '' : ' disabled') + '>' +
              (v && v.available ? 'Add to cart' : 'Sold out') +
            '</button>' +
          '</div>' +
          '<a class="qv-link" href="' + esc(p.url || ('/products/' + p.handle)) + '">View full details →</a>' +
        '</div>' +
      '</div>';
    qvRoot.innerHTML = html;
    qvRefreshAvail();
  }
  function qvRefreshAvail() {
    if (!qvState) return;
    var opts = qvState.opts;
    qvRoot.querySelectorAll('[data-qv-group]').forEach(function (g) {
      var i = +g.getAttribute('data-qv-group');
      g.querySelectorAll('[data-qv-val]').forEach(function (btn) {
        var test = opts.slice(); test[i] = btn.getAttribute('data-qv-val');
        var exists = false, avail = false;
        qvState.product.variants.forEach(function (v) {
          if (test.every(function (o, j) { return !o || v.options[j] === o; })) { exists = true; if (v.available) avail = true; }
        });
        btn.disabled = !exists;
        btn.classList.toggle('oos', exists && !avail);
      });
    });
  }
  function qvUpdate() {
    if (!qvState) return;
    var v = qvVariantFor(qvState.opts);
    var price = qvRoot.querySelector('[data-qv-price]');
    var cmp = qvRoot.querySelector('[data-qv-compare]');
    var save = qvRoot.querySelector('.qv-price .save');
    var add = qvRoot.querySelector('[data-qv-add]');
    var img = qvRoot.querySelector('[data-qv-img]');
    qvState.opts.forEach(function (o, i) {
      var lab = qvRoot.querySelector('[data-qv-optlabel="' + i + '"]');
      if (lab) lab.textContent = o || '';
    });
    if (!v) { if (add) { add.disabled = true; add.textContent = 'Unavailable'; } return; }
    if (price) price.textContent = fmt(v.price);
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    if (cmp) cmp.style.display = onSale ? '' : 'none';
    if (cmp && onSale) cmp.textContent = fmt(v.compare_at_price);
    if (save) { save.style.display = onSale ? '' : 'none'; if (onSale) save.textContent = 'Save ' + fmt(v.compare_at_price - v.price); }
    if (add) { add.disabled = !v.available; add.textContent = v.available ? 'Add to cart' : 'Sold out'; }
    if (img && v.featured_image && v.featured_image.src) img.src = imgSize(v.featured_image.src, '900x');
    qvRefreshAvail();
  }
  function qvOpen(handle) {
    if (!qvRoot) return;
    qvRoot.innerHTML = '<div class="qv-overlay" data-qv-close></div><div class="qv-card"><div class="qv-loading">Loading…</div></div>';
    qvRoot.classList.add('open');
    document.body.classList.add('no-scroll');
    var ready = qvCache[handle]
      ? Promise.resolve(qvCache[handle])
      : fetch('/products/' + handle + '.js').then(function (r) { if (!r.ok) throw new Error(); return r.json(); }).then(function (p) { qvCache[handle] = p; return p; });
    ready.then(function (p) {
      if (!qvRoot.classList.contains('open')) return;
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      qvState = { product: p, opts: first ? first.options.slice() : [], qty: 1 };
      qvRender();
    }).catch(function () {
      qvClose();
      window.location.href = '/products/' + handle;
    });
  }
  if (qvRoot) {
    // delegated: works for cards injected later (search results, upsells, recently viewed)
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-quick-view]') : null;
      if (t) { e.preventDefault(); qvOpen(t.getAttribute('data-quick-view')); return; }
      if (e.target.closest && e.target.closest('[data-qv-close]')) { qvClose(); return; }
      if (!qvState) return;
      var val = e.target.closest ? e.target.closest('[data-qv-val]') : null;
      if (val && !val.disabled && qvRoot.contains(val)) {
        var group = val.closest('[data-qv-group]');
        var i = +group.getAttribute('data-qv-group');
        group.querySelectorAll('[data-qv-val]').forEach(function (b) { b.classList.remove('sel'); });
        val.classList.add('sel');
        qvState.opts[i] = val.getAttribute('data-qv-val');
        qvUpdate();
        return;
      }
      var q = e.target.closest ? e.target.closest('[data-qv-q]') : null;
      if (q && qvRoot.contains(q)) {
        var input = qvRoot.querySelector('[data-qv-qty]');
        var n = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(q.getAttribute('data-qv-q'), 10));
        input.value = n; qvState.qty = n;
        return;
      }
      var thumb = e.target.closest ? e.target.closest('[data-qv-thumb]') : null;
      if (thumb && qvRoot.contains(thumb)) {
        qvRoot.querySelectorAll('[data-qv-thumb]').forEach(function (b) { b.classList.remove('active'); });
        thumb.classList.add('active');
        var im = qvRoot.querySelector('[data-qv-img]');
        if (im) im.src = imgSize(thumb.getAttribute('data-qv-thumb'), '900x');
        return;
      }
      var addBtn = e.target.closest ? e.target.closest('[data-qv-add]') : null;
      if (addBtn && qvRoot.contains(addBtn)) {
        var v = qvVariantFor(qvState.opts);
        if (!v) return;
        var input2 = qvRoot.querySelector('[data-qv-qty]');
        var qty = Math.max(1, parseInt(input2 && input2.value, 10) || 1);
        addBtn.disabled = true; addBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: v.id, quantity: qty })
        }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            addBtn.disabled = false; addBtn.textContent = 'Add to cart';
            if (!res.ok) { if (window.adToast) window.adToast(res.d.description || 'Could not add to cart'); return; }
            qvClose();
            if (window.adRefreshCart) window.adRefreshCart();
            if (window.adOpenCart) window.adOpenCart();
            document.dispatchEvent(new CustomEvent('cart:added', { detail: res.d }));
          })
          .catch(function () { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; });
      }
    });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') qvClose(); });
    document.addEventListener('input', function (e) {
      if (qvState && e.target.matches && e.target.matches('[data-qv-qty]')) {
        qvState.qty = Math.max(1, parseInt(e.target.value, 10) || 1);
      }
    });
  }

  /* ============ cart drawer: order note ============ */
  var noteArea = document.querySelector('[data-cart-note]');
  if (noteArea) {
    var noteHint = document.querySelector('[data-cart-note-hint]');
    var saveNote = debounce(function () {
      fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: noteArea.value })
      }).then(function (r) { return r.json(); }).then(function () {
        if (noteHint) { noteHint.textContent = 'Saved ✓'; noteHint.classList.add('ok');
          setTimeout(function () { noteHint.textContent = ''; noteHint.classList.remove('ok'); }, 2000); }
      });
    }, 600);
    noteArea.addEventListener('input', saveNote);
    document.addEventListener('cart:render', function (e) {
      var cart = e.detail;
      if (cart && document.activeElement !== noteArea) noteArea.value = cart.note || '';
    });
  }

  /* ============ cart drawer: discount codes ============ */
  var dcForm = document.querySelector('[data-discount-form]');
  if (dcForm) {
    var dcInput = dcForm.querySelector('input');
    var dcBtn = dcForm.querySelector('button');
    var dcMsg = document.querySelector('[data-discount-msg]');
    var dcPills = document.querySelector('[data-discount-pills]');
    var dcCodes = [];

    function dcSetMsg(text, cls) {
      if (!dcMsg) return;
      dcMsg.textContent = text || '';
      dcMsg.className = 'discount-msg' + (cls ? ' ' + cls : '');
    }
    function dcRenderPills() {
      if (!dcPills) return;
      dcPills.innerHTML = dcCodes.map(function (c) {
        return '<span class="pill">' + esc(c) + '<button type="button" data-discount-remove="' + esc(c) + '" aria-label="Remove code">×</button></span>';
      }).join('');
    }
    function dcSync(codes, addedCode) {
      return fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        var applied = cart.discount_codes;
        if (applied === undefined) {
          // storefront API without discount support — set the discount cookie instead
          if (addedCode) {
            return fetch('/discount/' + encodeURIComponent(addedCode)).then(function () {
              dcCodes = codes; dcRenderPills();
              dcSetMsg('Code saved — it will apply at checkout.', 'ok');
              return cart;
            });
          }
          dcCodes = codes; dcRenderPills();
          return cart;
        }
        dcCodes = applied.filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        var rejected = addedCode && applied.filter(function (d) {
          return d.code.toLowerCase() === addedCode.toLowerCase() && !d.applicable;
        })[0];
        if (rejected) {
          // drop the inapplicable code again so it doesn't linger on the cart
          dcSetMsg('“' + addedCode + '” doesn’t apply to this cart.', 'err');
          dcRenderPills();
          return fetch('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: dcCodes.join(',') })
          }).then(function (r) { return r.json(); }).then(function (c2) {
            if (window.adRefreshCart) window.adRefreshCart();
            return c2;
          });
        }
        if (addedCode) dcSetMsg('Code applied ✓', 'ok');
        dcRenderPills();
        if (window.adRefreshCart) window.adRefreshCart();
        return cart;
      });
    }
    dcForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = (dcInput.value || '').trim();
      if (!code) return;
      if (dcCodes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
        dcSetMsg('That code is already applied.', 'err'); return;
      }
      dcBtn.disabled = true; dcSetMsg('');
      dcSync(dcCodes.concat(code), code).then(function () {
        dcBtn.disabled = false; dcInput.value = '';
      }).catch(function () { dcBtn.disabled = false; dcSetMsg('Could not apply the code. Try again.', 'err'); });
    });
    document.addEventListener('click', function (e) {
      var rm = e.target.closest ? e.target.closest('[data-discount-remove]') : null;
      if (!rm) return;
      var code = rm.getAttribute('data-discount-remove');
      dcSync(dcCodes.filter(function (c) { return c !== code; }));
    });
    document.addEventListener('cart:render', function (e) {
      var cart = e.detail;
      if (cart && cart.discount_codes) {
        dcCodes = cart.discount_codes.filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        dcRenderPills();
      }
    });
  }

  /* ============ cart drawer: upsells ("Complete your bathroom") ============ */
  var upsell = document.querySelector('[data-cart-upsell]');
  if (upsell) {
    var upsellList = upsell.querySelector('[data-cart-upsell-list]');
    var recoCache = {};
    function renderUpsell(cart) {
      if (!cart || cart.item_count === 0) { upsell.hidden = true; return; }
      var inCart = cart.items.map(function (it) { return it.product_id; });
      var seedId = cart.items[0].product_id;
      var ready = recoCache[seedId]
        ? Promise.resolve(recoCache[seedId])
        : fetch('/recommendations/products.json?product_id=' + seedId + '&limit=6')
            .then(function (r) { return r.ok ? r.json() : { products: [] }; })
            .then(function (d) { recoCache[seedId] = d; return d; })
            .catch(function () { return { products: [] }; });
      ready.then(function (d) {
        var picks = (d.products || []).filter(function (p) {
          return inCart.indexOf(p.id) === -1 && p.available !== false;
        }).slice(0, 3);
        if (!picks.length) { upsell.hidden = true; return; }
        upsellList.innerHTML = picks.map(function (p) {
          var img = p.featured_image ? imgSize(p.featured_image, '120x') : '';
          var single = p.variants && p.variants.length === 1;
          var action = single
            ? '<button type="button" class="du-item__add" data-upsell-add="' + p.variants[0].id + '">Add +</button>'
            : '<a href="' + esc(p.url) + '" class="du-item__add" data-quick-view="' + esc(p.handle) + '">View</a>';
          return '<div class="du-item">' +
            '<a href="' + esc(p.url) + '" class="du-item__media">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '">' : '') + '</a>' +
            '<div class="du-item__body"><div class="du-item__name">' + esc(p.title) + '</div><div class="du-item__price">' + fmt(p.price) + '</div></div>' +
            action +
          '</div>';
        }).join('');
        upsell.hidden = false;
      });
    }
    document.addEventListener('cart:render', function (e) { renderUpsell(e.detail); });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-upsell-add]') : null;
      if (!btn) return;
      btn.disabled = true; btn.textContent = '…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(btn.getAttribute('data-upsell-add'), 10), quantity: 1 })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          btn.disabled = false; btn.textContent = 'Add +';
          if (!res.ok) { if (window.adToast) window.adToast(res.d.description || 'Could not add to cart'); return; }
          if (window.adRefreshCart) window.adRefreshCart();
          document.dispatchEvent(new CustomEvent('cart:added', { detail: res.d }));
        })
        .catch(function () { btn.disabled = false; btn.textContent = 'Add +'; });
    });
  }

  /* ============ recently viewed ============ */
  var RV_KEY = 'ad:recent';
  function rvList() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; }
  }
  window.adTrackRecent = function (handle) {
    if (!handle) return;
    try {
      var list = rvList().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 8)));
    } catch (e) {}
  };
  document.querySelectorAll('[data-recent-grid]').forEach(function (grid) {
    var exclude = grid.getAttribute('data-exclude') || '';
    var max = parseInt(grid.getAttribute('data-max'), 10) || 4;
    var handles = rvList().filter(function (h) { return h !== exclude; }).slice(0, max);
    var sectionEl = grid.closest('.rv-section');
    if (!handles.length) return;
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var cards = products.filter(Boolean).map(function (p) {
        var img = p.images && p.images[0] ? imgSize(p.images[0], '540x') : '';
        var v = p.variants && p.variants[0];
        var onSale = v && v.compare_at_price && v.compare_at_price > v.price;
        return '<a class="rv-card" href="' + esc(p.url || ('/products/' + p.handle)) + '">' +
          '<div class="rv-media">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</div>' +
          '<div class="rv-name">' + esc(p.title) + '</div>' +
          '<div class="rv-price">' + (onSale ? '<s>' + fmt(v.compare_at_price) + '</s>' : '') + fmt(p.price) + '</div>' +
        '</a>';
      }).join('');
      if (!cards) return;
      grid.innerHTML = cards;
      if (sectionEl) sectionEl.hidden = false;
    });
  });

  /* ============ PDP: share row ============ */
  var share = document.querySelector('[data-share]');
  if (share) {
    var copyBtn = share.querySelector('[data-share-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var url = share.getAttribute('data-share-url') || window.location.href.split('?')[0];
        var done = function () { if (window.adToast) window.adToast('Link copied'); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = url; document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          ta.remove();
        }
      });
    }
  }
})();
